import React, { useState } from "react";
import TablePageLayout from "components/TablePageLayout";
import EventDashboard from "components/dashboard/EventDashboard"

export default function DashboardPage() {
  
  return (
    <TablePageLayout>
        <EventDashboard /> 
    </TablePageLayout>
  );
}
